"use strict";

var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step2;
    try {
      var _loop = function _loop() {
        var key = _step2.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  createStore: function createStore() {
    return _createStore;
  },
  createZustandStore: function createZustandStore() {
    return _createZustandStore;
  },
  extendActions: function extendActions() {
    return _extendActions;
  },
  extendSelectors: function extendSelectors() {
    return _extendSelectors;
  },
  generateStateActions: function generateStateActions() {
    return _generateStateActions;
  },
  generateStateGetSelectors: function generateStateGetSelectors() {
    return _generateStateGetSelectors;
  },
  generateStateHookSelectors: function generateStateHookSelectors() {
    return _generateStateHookSelectors;
  },
  generateStateTrackedHooksSelectors: function generateStateTrackedHooksSelectors() {
    return _generateStateTrackedHooksSelectors;
  },
  immerMiddleware: function immerMiddleware() {
    return _immerMiddleware;
  },
  mapValuesKey: function mapValuesKey() {
    return _mapValuesKey;
  },
  pipe: function pipe() {
    return _pipe;
  },
  storeFactory: function storeFactory() {
    return _storeFactory2;
  }
});
module.exports = __toCommonJS(src_exports);

// src/createStore.ts
var import_immer2 = require("immer");
var import_react_tracked = require("react-tracked");
var import_middleware = require("zustand/middleware");
var import_traditional = require("zustand/traditional");
var import_vanilla = require("zustand/vanilla");

// src/middlewares/immer.middleware.ts
var import_immer = require("immer");
var _immerMiddleware = function _immerMiddleware(config) {
  return function (set, get, api) {
    var setState = function setState(fn, actionName) {
      return set((0, import_immer.produce)(fn), true, actionName);
    };
    api.setState = setState;
    return config(setState, get, api);
  };
};

// src/utils/generateStateActions.ts
var _generateStateActions = function _generateStateActions(store, storeName) {
  var actions = {};
  Object.keys(store.getState()).forEach(function (key) {
    actions[key] = function (value) {
      var prevValue = store.getState()[key];
      if (prevValue === value) return;
      var actionKey = key.replace(/^\S/, function (s) {
        return s.toUpperCase();
      });
      store.setState(function (draft) {
        draft[key] = value;
      }, "@@".concat(storeName, "/set").concat(actionKey));
    };
  });
  return actions;
};

// src/utils/generateStateGetSelectors.ts
var _generateStateGetSelectors = function _generateStateGetSelectors(store) {
  var selectors = {};
  Object.keys(store.getState()).forEach(function (key) {
    selectors[key] = function () {
      return store.getState()[key];
    };
  });
  return selectors;
};

// src/utils/generateStateHookSelectors.ts
var _generateStateHookSelectors = function _generateStateHookSelectors(useStore, store) {
  var selectors = {};
  Object.keys(store.getState()).forEach(function (key) {
    selectors[key] = function (equalityFn) {
      return useStore(function (state) {
        return state[key];
      }, equalityFn);
    };
  });
  return selectors;
};

// src/utils/generateStateTrackedHooksSelectors.ts
var _generateStateTrackedHooksSelectors = function _generateStateTrackedHooksSelectors(useTrackedStore, store) {
  var selectors = {};
  Object.keys(store.getState()).forEach(function (key) {
    selectors[key] = function () {
      return useTrackedStore()[key];
    };
  });
  return selectors;
};

// src/utils/pipe.ts
function _pipe(x) {
  for (var _len = arguments.length, fns = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    fns[_key - 1] = arguments[_key];
  }
  return fns.reduce(function (y, fn) {
    return fn(y);
  }, x);
}

// src/utils/extendActions.ts
var _extendActions = function _extendActions(builder, api) {
  var actions = builder(api.set, api.get, api);
  return __spreadProps(__spreadValues({}, api), {
    set: __spreadValues(__spreadValues({}, api.set), actions)
  });
};

// src/utils/extendSelectors.ts
var _extendSelectors = function _extendSelectors(builder, api) {
  var use = __spreadValues({}, api.use);
  var useTracked = __spreadValues({}, api.useTracked);
  var get = __spreadValues({}, api.get);
  Object.keys(builder(api.store.getState(), api.get, api)).forEach(function (key) {
    use[key] = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return api.useStore(function (state) {
        var selectors = builder(state, api.get, api);
        var selector = selectors[key];
        return selector.apply(void 0, args);
      });
    };
    useTracked[key] = function () {
      var trackedState = api.useTrackedStore();
      var selectors = builder(trackedState, api.get, api);
      var selector = selectors[key];
      return selector.apply(void 0, arguments);
    };
    get[key] = function () {
      var selectors = builder(api.store.getState(), api.get, api);
      var selector = selectors[key];
      return selector.apply(void 0, arguments);
    };
  });
  return __spreadProps(__spreadValues({}, api), {
    get: get,
    use: use,
    useTracked: useTracked
  });
};

// src/utils/storeFactory.ts
var _storeFactory2 = function _storeFactory(api) {
  return __spreadProps(__spreadValues({}, api), {
    extendSelectors: function extendSelectors(builder) {
      return _storeFactory2(_extendSelectors(builder, api));
    },
    extendActions: function extendActions(builder) {
      return _storeFactory2(_extendActions(builder, api));
    }
  });
};

// src/createStore.ts
var _createStore = function _createStore(name) {
  return function (initialState) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _a, _b;
    var _options$middlewares = options.middlewares,
      _middlewares = _options$middlewares === void 0 ? [] : _options$middlewares,
      devtools = options.devtools,
      persist = options.persist,
      immer = options.immer;
    (0, import_immer2.setAutoFreeze)((_a = immer == null ? void 0 : immer.enabledAutoFreeze) != null ? _a : false);
    if (immer == null ? void 0 : immer.enableMapSet) {
      (0, import_immer2.enableMapSet)();
    }
    var middlewares = [_immerMiddleware].concat(_toConsumableArray(_middlewares));
    if (persist == null ? void 0 : persist.enabled) {
      var opts = __spreadProps(__spreadValues({}, persist), {
        name: (_b = persist.name) != null ? _b : name
      });
      middlewares.push(function (config) {
        return (0, import_middleware.persist)(config, opts);
      });
    }
    if (devtools == null ? void 0 : devtools.enabled) {
      middlewares.push(function (config) {
        return (0, import_middleware.devtools)(config, __spreadProps(__spreadValues({}, devtools), {
          name: name
        }));
      });
    }
    middlewares.push(import_vanilla.createStore);
    var pipeMiddlewares = function pipeMiddlewares(createState) {
      return _pipe.apply(void 0, [createState].concat(_toConsumableArray(middlewares)));
    };
    var store = pipeMiddlewares(function () {
      return initialState;
    });
    var useStore = function useStore(selector, equalityFn) {
      return (0, import_traditional.useStoreWithEqualityFn)(store, selector, equalityFn);
    };
    var stateActions = _generateStateActions(store, name);
    var mergeState = function mergeState(state, actionName) {
      store.setState(function (draft) {
        Object.assign(draft, state);
      }, actionName || "@@".concat(name, "/mergeState"));
    };
    var setState = function setState(fn, actionName) {
      store.setState(fn, actionName || "@@".concat(name, "/setState"));
    };
    var hookSelectors = _generateStateHookSelectors(useStore, store);
    var getterSelectors = _generateStateGetSelectors(store);
    var useTrackedStore = (0, import_react_tracked.createTrackedSelector)(useStore);
    var trackedHooksSelectors = _generateStateTrackedHooksSelectors(useTrackedStore, store);
    var api = {
      get: __spreadValues({
        state: store.getState
      }, getterSelectors),
      name: name,
      set: __spreadValues({
        state: setState,
        mergeState: mergeState
      }, stateActions),
      store: store,
      use: hookSelectors,
      useTracked: trackedHooksSelectors,
      useStore: useStore,
      useTrackedStore: useTrackedStore,
      extendSelectors: function extendSelectors() {
        return api;
      },
      extendActions: function extendActions() {
        return api;
      }
    };
    return _storeFactory2(api);
  };
};
var _createZustandStore = _createStore;

// src/utils/mapValuesKey.ts
var import_lodash = __toESM(require("lodash.mapvalues"));
var _mapValuesKey = function _mapValuesKey(key, obj) {
  return (0, import_lodash.default)(obj, function (value) {
    return value[key];
  });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  createStore: _createStore,
  createZustandStore: _createZustandStore,
  extendActions: _extendActions,
  extendSelectors: _extendSelectors,
  generateStateActions: _generateStateActions,
  generateStateGetSelectors: _generateStateGetSelectors,
  generateStateHookSelectors: _generateStateHookSelectors,
  generateStateTrackedHooksSelectors: _generateStateTrackedHooksSelectors,
  immerMiddleware: _immerMiddleware,
  mapValuesKey: _mapValuesKey,
  pipe: _pipe,
  storeFactory: _storeFactory2
});